package site.shadadman.pages.worklog.alfatechnology

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initAlfatechnologyPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/alfatechnology/alfatechnology.md", FrontMatterElement.Builder { addScalar("title", "Alfa Technology Worklog"); }))
}

@Page("/worklog/alfatechnology/alfatechnology")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun AlfatechnologyPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("alfa-technology") }) {
        org.jetbrains.compose.web.dom.Text("Alfa Technology")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/alfatechnology/oct122014AlfaTechnologyFirstSprint") {
                org.jetbrains.compose.web.dom.Text("First Sprint")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/alfatechnology/jan172015AlfaTechnologyGPS") {
                org.jetbrains.compose.web.dom.Text("GPS Challenges")
            }
        }
    }
}
